export default "__VITE_ASSET__fce16b62__"